export enum DbThingContentType {
    Item = 1,
    Pet = 2,
    Title = 3,
}
